module.exports = __webpack_public_path__ + "img/img4.86e1ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img4.png
// module id = 213
// module chunks = 0